import React, { useEffect, useState } from "react";

const DayTracker = ({
  savedPaymentList,
  setShowPopup,
  setPopupType,
  isUserOnIos,
}) => {
  const [paymentsDays, setPaymentsDays] = useState(1);

  useEffect(() => {
    const calculateDaysPassed = () => {
      if (savedPaymentList.length > 0) {
        // Get the creation date of the first payment
        const firstPaymentCreatedAt = new Date(savedPaymentList[0].createdAt);

        // Get today's date
        const today = new Date();

        // Set both dates to midnight
        firstPaymentCreatedAt.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        // Calculate the difference in days
        const differenceInTime =
          today.getTime() - firstPaymentCreatedAt.getTime();
        const differenceInDays =
          Math.floor(differenceInTime / (1000 * 3600 * 24)) + 1;

        // Set the number of days
        setPaymentsDays(differenceInDays);
      }
    };

    calculateDaysPassed();
  }, [savedPaymentList]);

  return (
    <div
      className="statViewer"
      style={{
        position: "absolute",
        bottom: isUserOnIos ? "4rem" : "3rem",
        right: "1rem",
        left: "1rem",
      }}
    >
      <div className="">
        {`Day: ${paymentsDays}`} <br></br>
        <div
          style={{
            fontWeight: "normal",
            textTransform: "none",
          }}
        >
          {paymentsDays >= 8 ? (
            <button
              style={{ paddingLeft: 0 }}
              className="minButtonC2A"
              onClick={() => {
                setShowPopup(true);
                setPopupType("updateWeekly");
              }}
            >
              {"update weekly payments"}
            </button>
          ) : (
            <>{"you can update payments after 7 days"}</>
          )}
        </div>
      </div>
    </div>
  );
};

export default DayTracker;
